import React from 'react';
export function LegacySection() {
  return <section className="bg-charcoal py-[60px] md:py-[80px] lg:py-[120px] px-6" data-id="element-123">
      <div className="max-w-[900px] mx-auto text-center" data-id="element-124">
        {/* Eyebrow Label */}
        <span className="block text-[14px] font-semibold uppercase tracking-[0.15em] text-gold mb-8" data-id="element-125">
          A Legacy of Land and Vine
        </span>

        {/* Main Headline */}
        <h2 className="text-[32px] md:text-[36px] lg:text-[48px] leading-[1.2] font-optima text-white mb-10 font-[500]" data-id="element-126">
          The story of Glenlofty is etched into the ancient soils of the
          Pyrenees.
        </h2>

        {/* Body Copy */}
        <div className="space-y-6 text-[16px] md:text-[17px] lg:text-[18px] leading-[1.7] font-optima text-white/90" data-id="element-127">
          <p data-id="element-128">
            The story of Glenlofty is etched into the ancient soils of the
            Pyrenees. Our land's agricultural heritage dates back to 1839, a
            legacy of pioneering spirit that we honor in our approach to
            viticulture. When the first vines were planted in 1995, it was with
            a clear vision: to create a vineyard that could rival the great
            cool-climate sites of the world. The estate's unique terroir, with
            its granitic sands and cool, continental climate, proved to be the
            perfect canvas.
          </p>
          <p data-id="element-129">
            Today, Glenlofty Estate is recognized as a 4-star Halliday winery, a
            mark of our unwavering commitment to excellence. We believe that
            great wine is not made, but grown. It is born in the vineyard,
            nurtured by the hands of our dedicated team, and guided into the
            bottle with minimal intervention. Our story is one of passion,
            patience, and a profound respect for the land we are privileged to
            call home.
          </p>
        </div>
      </div>
    </section>;
}